<template>
  <exercicio></exercicio>
</template>

<script>
import exercicio from '@/custom/exercicio'
var componentDefinition = {
  components: { exercicio },
  route: {
    name: 'COMPLETE',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/complete/:refresh?',
    meta: {
      title: 'Complete a Lacuna',
      hasErrorHandler: true,
      hidden: true
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  data: function () {
    return {}
  },
  methods: {
  }
}
export default componentDefinition
</script>
